export const xeroCallbackError = 'XERO_CALLBACK_ERROR';
export const xeroAuthenticationError = 'XERO_AUTHENTICATION_ERROR';
export const xeroNoContactIdError = 'XERO_NO_CONTACT_ID_ERROR';
export const generalXeroError = 'GENERAL_XERO_ERROR';